import React from 'react';
import styled from 'styled-components';

interface StatItemProps {
  number: string;
  label: string;
}

const Item = styled.div`
  text-align: center;
`;

const Number = styled.div`
  font-size: ${({ theme }) => theme.font.size.xl5};
  font-weight: ${({ theme }) => theme.font.weight.extrabold};
  line-height: ${({ theme }) => theme.font.lineHeight.none};
  color: ${({ theme }) => theme.color.textInverse};
  margin-bottom: ${({ theme }) => theme.space[2]};
  background: ${({ theme }) => theme.gradient.brand};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const Label = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme }) => theme.alpha.white[80]};
  text-transform: uppercase;
  letter-spacing: ${({ theme }) => theme.font.letterSpacing.wide};
`;

const StatItem: React.FC<StatItemProps> = ({ number, label }) => {
  return (
    <Item>
      <Number>{number}</Number>
      <Label>{label}</Label>
    </Item>
  );
};

export default StatItem;
